import moment from 'moment';
import type { HiredCandidate } from 'store/reducers/jobReducer';
import type { TableRow } from '_atoms/Table/types';
import { STATUS_TYPES } from '_atoms/Status';
import type { StatusType } from '_atoms/Status';
import { STATUSES } from 'constants/user';

export interface HiredListItem {
  uuid: string;
  job_assignment?: string;
  full_name_latin?: string;
  full_name_local?: string;
  team_lead: { full_name?: string };
  recruiter?: { full_name?: string } | null;
  opening: {
    experience_level?: string;
    expected?: string;
    uuid?: string;
    [key: string]: unknown;
  };
  location: { uuid: string; name?: string };
  status?: string;
  entry_date?: string;
  probation_period?: number | string;
  comment?: string;
}

export interface HiredRow extends TableRow {
  job_assignment: string;
  candidate: { uuid: string; fullNameLatin?: string; fullNameLocal?: string };
  team_lead: string;
  recruiter?: string;
  experience_level?: string;
  location: { value: string; label: string };
  status: { type?: StatusType; status?: string };
  opening: {
    uuid?: string;
    level?: string;
    expected?: string;
    experience_level?: string;
    offices: Array<{ value: string; label: string }>;
    [key: string]: unknown;
  };
  entry_date: string;
  probation_period?: string | number;
  action: { show?: boolean; action: (record: HiredRow) => void };
  comment?: string;
}

export const dataMapper = (list: HiredCandidate[], action: (record: HiredRow) => void): HiredRow[] =>
  list.map(el => {
    const item = el as unknown as HiredListItem;
    return {
      uuid: item.uuid,
      job_assignment: item.job_assignment ?? '',
      candidate: { uuid: item.uuid, fullNameLatin: item.full_name_latin, fullNameLocal: item.full_name_local },
      team_lead: item.team_lead.full_name ?? '',
      recruiter: item.recruiter?.full_name,
      experience_level: item.opening.experience_level,
      location: { value: item.location.uuid, label: item.location.name ?? '' },
      status: {
        type: item.status === STATUSES.FIRED ? STATUS_TYPES.RED : STATUS_TYPES.GREEN,
        status: item.status,
      },
      opening: {
        ...item.opening,
        expected: item.opening.expected,
        level: item.opening.experience_level,
        offices: [{ value: item.location.uuid, label: item.location.name ?? '' }],
      },
      entry_date: item.entry_date ? moment(item.entry_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : '',
      probation_period: item.probation_period,
      action: { show: item.status === STATUSES.HIRED, action },
      comment: item.comment,
    };
  });
